import {Injectable} from '@angular/core';
import {VideoUserVolumeUpdateAction} from '../stores/root-store/actions/timeline.action';
import {LocalStorageService} from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class VolumeService {

    constructor(private localStorageService: LocalStorageService) {
    }

    saveVolumeToLocalStorage(changedUserVolume: number) {
        this.localStorageService.setItem('userVolume', changedUserVolume.toString());
    }

    setInitialUserVolume() {
        const volumeFromLocalStorage = this.getUserVolumeFromLocalStorage();

        return VideoUserVolumeUpdateAction({
            changedUserVolume: volumeFromLocalStorage ? +volumeFromLocalStorage : 100
        });
    }

    private getUserVolumeFromLocalStorage() {
        return this.localStorageService.getItem('userVolume');
    }
}
